import { GridReadyEvent, RowDoubleClickedEvent, RowSelectedEvent, RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { AgFns, GridOptionsExt, RowSelectionSingle } from 'app/shared/ag-fns';
import { UtilFns } from 'app/shared/util-fns';
import _ from 'lodash';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthUser } from './auth.service';
import { DialogBaseComponent, DialogParams } from './dialog-base.component';
import { DomainService } from './domain.service';

export interface AuthUserSelectDialogParams extends DialogParams {
  authUsers: AuthUser[];
  rowSelection?: RowSelectionOptions
}

@Component({
    templateUrl: './auth-user-select-dialog.component.html',
    standalone: false
})
export class AuthUserSelectDialogComponent extends DialogBaseComponent<AuthUserSelectDialogParams> {
  UtilFns = UtilFns;
  params: AuthUserSelectDialogParams;
  mainGridOptions : GridOptionsExt;
  selectedItem: AuthUser;
  allItems: AuthUser[];


  // static async show(parent: IDialogParent, data: AuthUserSelectDialogParams) {
  //   data =  { width: '850px', height: '650px', ...data }
  //   return DialogBaseComponent.open(AuthUserSelectDialogComponent, parent, data);
  // }

  constructor(
      public config: DynamicDialogConfig<AuthUserSelectDialogParams>,
      public dialogRef: DynamicDialogRef,
      public domainService: DomainService
    ) {
      super(config, dialogRef, domainService);
      this.params = this.config.data;


    this.config.header ="Select Authorized User";
    // this.setTitle(title);

    this.prepare();
    this.isPageReady = true;
  }

  async prepare() {
    this.mainGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onGridReady,
      onRowSelected: this.onRowSelected,
      onRowDoubleClicked: this.onRowDoubleClick,
      getRowId: p => (p.data as AuthUser).initials,
      onFirstDataRendered: p => p.api.sizeColumnsToFit(),
      singleClickEdit: true,
      rowSelection: this.params.rowSelection ?? RowSelectionSingle,
      stopEditingWhenCellsLoseFocus: true,
    });

    this.allItems = _.orderBy(this.params.authUsers, au => au.displayName);

  }

  onGridReady(event: GridReadyEvent) {
    const colDefs = [
      { headerName: 'Display Name', field: 'displayName' , },
      { headerName: 'Initials', field: 'initials' },
    ];

    const sortModel = [
      { colId: 'displayName', sort: 'asc' as const },
    ];
    AgFns.initGrid(event, colDefs, sortModel);
  }

  async onRowSelected(e: RowSelectedEvent) {
    // check if a deselect event and ignore
    if (!e.node.isSelected()) {
      return;
    }

    this.selectedItem = e.data as AuthUser;
  }

  onRowDoubleClick(e: RowDoubleClickedEvent) {
    if (!e.node.isSelected()) {
      return;
    }
    const item = e.data as AuthUser;
    this.dialogRef.close([item]);
  }

  ok() {
    const r = this.mainGridOptions.apiX.getSelectedRows()
    this.dialogRef.close(r);
  }

  cancel() {
    this.dialogRef.close([]);
  }

}
